import React, { useState } from "react";
import Menu from "../../../components/layout/menu";
import Grafico1 from "../../../components/dashboard/inOutPercentagePerSite/index";
import Grafico2 from "../../../components/dashboard/mediaWeightArea/index";
import Grafico3 from "../../../components/dashboard/weightComparative/index";
import Grafico4 from "../../../components/dashboard/weightingFrecuency/index";
import Grafico5 from "../../../components/dashboard/mediaWeightScatter/index";
import Grafico6 from "../../../components/dashboard/compliancePercentage/index";
import Grafico7 from "../../../components/dashboard/siteComparative/index";
import Grafico8 from "../../../components/dashboard/vehicleTypeFrecuency/index";
import Programate from "../../../components/layout/footer";

export default function Dashboard() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <div className="flex w-full min-h-screen">
   
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div
        className={`flex-1 transition-all duration-300 ml-0 ${isMenuOpen ? 'lg:ml-[216px]  sm:ml-[0] md:ml-[0] ' : 'ml-0'} w-[84%] `}
      >
        <div className="flex flex-col justify-between min-h-screen">
          <div>
            <div className="pt-40 lg:pt-32 2xl:pt-[7rem]">
              <p className="text-[32px] font-itcbold text-[#007696] text-center">Dashboard</p>
              <p className="text-[20px] px-4 sm:px-6 lg:px-8 mt-5 font-itcmedium text-[#007696]">Porcentaje de Llegadas y Salidas por Plantas</p>
              <div className="px-4 sm:px-6 lg:px-8 mt-3">
                <Grafico1 />
              </div>
            </div>
    
            <div className="mt-20">
              <div className="px-4 sm:px-6 lg:px-8 mt-8">
                <Grafico2 />
              </div>
            </div>
    
            <div className="mt-16">
              <div className="px-4 sm:px-6 lg:px-8">
                <Grafico3 />
              </div>
            </div>
    
            <div className="flex mt-8 px-4 sm:px-6 lg:px-8 space-x-10">
              <div className="w-full sm:w-[48%] md:w-[50%]">
                <Grafico4 />
              </div>
              <div className="w-full sm:w-[48%] md:w-[50%]">
                <Grafico5 />
              </div>
            </div>
    
            <div className="mt-16">
              <div className="px-4 sm:px-6 lg:px-8">
                <Grafico6 />
              </div>
            </div>
    
            <div className="mt-16">
              <div className="px-4 sm:px-6 lg:px-8">
                <Grafico7 />
              </div>
            </div>
    
            <div className="mt-16 mb-32">
              <div className="px-4 sm:px-6 lg:px-8 ">
                <Grafico8 />
              </div>
            </div>
          </div>
          <Programate/>
        </div>
      </div>
    </div>
  );
}
